import { ButtonHTMLAttributes, forwardRef, useId } from 'react';
import { cn, Spinner } from '@fe-learner-common';

export interface A11yButtonProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading?: boolean;
}

export const A11yButton = forwardRef<HTMLButtonElement, A11yButtonProps>(
  (
    { children, isLoading, className, disabled, onClick, onKeyDown, ...rest },
    ref,
  ) => {
    const id = useId();

    return (
      <button
        ref={ref}
        aria-disabled={disabled}
        onClick={(e) => {
          if (disabled) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }
          onClick?.(e);
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && disabled) {
            e.preventDefault();
            e.stopPropagation();
            return;
          }
          onKeyDown?.(e);
        }}
        className={cn(
          'relative ',
          {
            'cursor-not-allowed': disabled,
          },
          className,
        )}
        {...rest}
      >
        {isLoading && (
          <span className="absolute inset-0 flex items-center justify-center rounded-[inherit] bg-inherit hover:bg-inherit">
            <Spinner name={`button-spinner-${id}`} />
          </span>
        )}
        {children}
      </button>
    );
  },
);
A11yButton.displayName = 'A11yButton';
